export default "__VITE_ASSET__DSv1HJ41__"